import { IBrandQuality } from "@/models/IBrandQuality";

import { BaseRepository } from "@/repositories/BaseRepository";

class BrandQualityRepository extends BaseRepository<IBrandQuality> {
    constructor() {
        super("/brandsQuality");
    }
}

const brandQualityRepository = new BrandQualityRepository();

export { BrandQualityRepository, brandQualityRepository };
